var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_15713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 11H16.8334",
    stroke: "#454551",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 14H16.8334",
    stroke: "#454551",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 19.25C3.7312 19.25 4.11273 19.092 4.39403 18.8107C4.67534 18.5294 4.83337 18.1478 4.83337 17.75V6.5C4.83337 6.30109 4.91239 6.11032 5.05304 5.96967C5.1937 5.82902 5.38446 5.75 5.58337 5.75H20.5834C20.7823 5.75 20.9731 5.82902 21.1137 5.96967C21.2544 6.11032 21.3334 6.30109 21.3334 6.5V17.75C21.3334 18.1478 21.1753 18.5294 20.894 18.8107C20.6127 19.092 20.2312 19.25 19.8334 19.25H3.33337Z",
    stroke: "#454551",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 19.25C2.93555 19.25 2.55402 19.092 2.27271 18.8107C1.99141 18.5294 1.83337 18.1478 1.83337 17.75V8.75",
    stroke: "#454551",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_15713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333374 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFeed);
export default __webpack_public_path__ + "static/media/my-feed.980b86a460125c7cfdb83fb79b4ca801.svg";
export { ForwardRef as ReactComponent };